import axios from '../axios-default';

const serverLogUrl = 'logger/sendFrontendLog';

export async function sendLogToServer(logerObj) {
    try {
        const request = {
            error: logerObj,
        };
        const logResult = await axios.post(serverLogUrl, request);
    } catch (e) {
        console.log('Send Log To Server Error:', e);
    }
}
